import _regeneratorRuntime from "D:/work/code/2026/Halov2-Fishery-Upgrade/halov-web/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _createForOfIteratorHelper from "D:/work/code/2026/Halov2-Fishery-Upgrade/halov-web/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import _asyncToGenerator from "D:/work/code/2026/Halov2-Fishery-Upgrade/halov-web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.function.name.js";
export default {
  name: 'self_diagnosis_breed',
  props: {
    breedId: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      pageConfig: {
        editPageName: '选择品种',
        queryFunName: 'breedQuery',
        dicTreeFunName: 'dictionaryCache'
      },
      dicData: {
        typeUpperCode: 'Fishery_Breed_Type',
        configTypes: [],
        configTypeOptions: {},
        configTypeLabels: {}
      },
      breed_id: this.breedId
    };
  },
  mounted: function mounted() {
    var _this = this;
    this.$api[this.pageConfig.dicTreeFunName](this.dicData.typeUpperCode).then(/*#__PURE__*/function () {
      var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(res) {
        var _iterator, _step, item;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!res.data) {
                _context.next = 6;
                break;
              }
              _this.dicData.configTypes = res.data;
              _iterator = _createForOfIteratorHelper(res.data);
              try {
                for (_iterator.s(); !(_step = _iterator.n()).done;) {
                  item = _step.value;
                  _this.$set(_this.dicData.configTypeOptions, item.code, {
                    SeaWater: [],
                    FreshWater: []
                  });
                  _this.$set(_this.dicData.configTypeLabels, item.code, item.name);
                }
              } catch (err) {
                _iterator.e(err);
              } finally {
                _iterator.f();
              }
              _context.next = 6;
              return _this.query();
            case 6:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());
  },
  methods: {
    query: function query() {
      var _this2 = this;
      this.$api[this.pageConfig.queryFunName]({
        page: 1,
        limit: -1
      }).then(function (res) {
        _this2.breedObj = {};
        var _iterator2 = _createForOfIteratorHelper(res.data),
          _step2;
        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var item = _step2.value;
            _this2.dicData.configTypeOptions[item.breedType][item.waterType].push(item);
            _this2.breedObj[item.id] = item;
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
        console.log('this.dicData.configTypeOptions', _this2.dicData.configTypeOptions);
      });
    },
    sel: function sel() {
      if (!this.breed_id) {
        this.$message.info('请先选择品种');
        return;
      }
      this.$emit('child-breed-sel', this.breedObj[this.breed_id]);
    }
  }
};